import React, {useEffect, useRef, useState} from 'react';
import * as THREE from 'three';
import {Carousel} from 'antd';
import 'antd/dist/reset.css'; // or 'antd/dist/antd.css' depending on version

import {
    WebGLRenderer, Scene, PerspectiveCamera,
    AmbientLight, DirectionalLight, PointLight, Clock
} from 'three';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls';
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {EffectComposer} from 'three/examples/jsm/postprocessing/EffectComposer';
import {RenderPass} from 'three/examples/jsm/postprocessing/RenderPass';
import {UnrealBloomPass} from 'three/examples/jsm/postprocessing/UnrealBloomPass';
import Navbar from "../Navbar/Navbar";
import Fotter from "../Fotter/Fotter";
import classes from './Awfive.module.scss';
import IGESViewer from "../components/Igswiever";

function Awfive() {
    const containerRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const carouselRef = useRef(null);


    useEffect(() => {
        let renderer: WebGLRenderer, scene: Scene, camera: PerspectiveCamera, controls: OrbitControls,
            composer: EffectComposer;
        let model: THREE.Group;

        const init = () => {
            scene = new Scene();

            camera = new PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
            camera.position.z = 10;

            renderer = new WebGLRenderer({alpha: true, antialias: true});
            renderer.setSize(window.innerWidth, window.innerHeight);
            renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
            renderer.outputColorSpace = THREE.SRGBColorSpace;
            renderer.physicallyCorrectLights = true;

            if (containerRef.current) {
                containerRef.current.appendChild(renderer.domElement);
            }

            scene.add(new AmbientLight(0xffffff, 0.8));
            const dirLight = new DirectionalLight(0xffffff, 0.8);
            dirLight.position.set(5.5, 5.5, 5.5);
            scene.add(dirLight);

            const pointLight = new PointLight(0xffffff, 2, 10);
            pointLight.position.set(0, 5, 5);
            scene.add(pointLight);

            controls = new OrbitControls(camera, renderer.domElement);
            controls.enableDamping = true;
            controls.dampingFactor = 0.1;

            composer = new EffectComposer(renderer);
            composer.addPass(new RenderPass(scene, camera));
            composer.addPass(new UnrealBloomPass(new THREE.Vector2(window.innerWidth, window.innerHeight), 0.5, 0.2, 0.3));

            controls.addEventListener('change', () => {
                composer.render();
            });

            loadModel();
        };

        const loadModel = () => {
            const loader = new GLTFLoader();
            loader.load(
                '/Models/AW25.glb',
                (gltf) => {
                    model = gltf.scene;
                    model.scale.set(5.5, 5.5, 5.5);
                    model.position.set(0, 1.8, 0);

                    model.traverse((child: any) => {
                        if (child.isMesh) {
                            child.material = new THREE.MeshStandardMaterial({
                                color: 0xffffff,
                                roughness: 0.5,
                                metalness: 0.5,
                            });
                        }
                    });

                    scene.add(model);
                    composer.render(); // Only render once on load
                    setLoading(false);
                },
                undefined,
                (err) => {
                    console.error('Error loading model:', err);
                    setLoading(false);
                    setError(true);
                }
            );
        };

        const onWindowResize = () => {
            camera.aspect = window.innerWidth / window.innerHeight;
            camera.updateProjectionMatrix();
            renderer.setSize(window.innerWidth, window.innerHeight);
            composer.setSize(window.innerWidth, window.innerHeight);
            composer.render();
        };

        init();
        window.addEventListener('resize', onWindowResize);

        return () => {
            window.removeEventListener('resize', onWindowResize);
            controls.dispose();
            renderer.dispose();

            if (model) {
                model.traverse((child: any) => {
                    if (child.isMesh) {
                        child.geometry.dispose();
                        if (Array.isArray(child.material)) {
                            child.material.forEach((mat) => mat.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                });
            }

            if (containerRef.current) {
                containerRef.current.removeChild(renderer.domElement);
            }
        };
    }, []);

    return (
        <div>
            <div className={classes['aw-container']}>
                <Navbar/>
                <div className={classes['aw-section-one']}>
                    <h3>AW5</h3>
                    <div className={classes['aw-image']}></div>
                </div>
                <div className={classes['sections']}>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['child-img']}></div>
                        <h2>Range</h2>
                        <p>30 km</p>

                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['weight-img']}></div>
                        <h2>Weight</h2>
                        <p>3.5 kg</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['time-img']}></div>
                        <h2>Flight time</h2>
                        <p>60-80 min</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['altitude-img']}></div>
                        <h2>Maximum altitude</h2>
                        <p>4000 m</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['speed-img']}></div>
                        <h2>Speed</h2>
                        <p>65-85 km/h</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['payload-img']}></div>
                        <h2>Payload</h2>
                        <p>Camera</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['lunch-img']}></div>
                        <h2>Launch</h2>
                        <p>By hand</p>
                    </div>
                    <div className={classes[['sections-child']]}>
                        <div className={classes['landing-img']}></div>
                        <h2>Landing</h2>
                        <p>By parachute</p>
                    </div>
                </div>


                <div className={classes['paragraph-section']}>
                    <div className={classes['p-Container']}>
<h2 className={classes['h']} style={{fontSize: '34px', marginTop: '40px'}}> Key Features</h2>
                        <br/>
                        <br/>

                        <p>
                               <ul>
                                   <li>Two types of payload: high-definition photo camera or video camera with gimbal.</li>

                               </ul>
                                <br/>
                                <ul>
                                    <li>Secure radio communication.</li>
                                </ul>
                                <br/>
                                <ul>
                                    <li>Launch by hand and parachute landing enables launching from almost any terrain.</li>
                                </ul>
                                <br/>
                                <ul>
                                    <li>Quick-detachable wing and stabilizer for fast assembly and landing protection.</li>
                                </ul>
                                <br/>
                              <ul>
                                  <li>  Communication with UAV allows adjustments during flight.</li>
                              </ul>
                            </p>

                        <div className={classes['paragraph-small-container']}>
                            {/*<div className={classes['paragraph-small']}>KEY FEATURES</div>*/}
                            {/*<div className={classes['paragraph-small']}>KEY FEATURES</div>*/}
                        </div>
                    </div>
                </div>


                <div style={{width: '100%', height: '95vh', margin: 'auto', marginBottom: '100px'}}>
                    {/*<div*/}
                    {/*    ref={containerRef}*/}
                    {/*    className={classes['threejs-figure']}*/}
                    {/*    style={{ width: '80%', height: '100%', backgroundColor: 'white', position: 'relative' }}*/}
                    {/*>*/}
                    {/*    {loading && (*/}
                    {/*        <div style={{*/}
                    {/*            position: 'absolute',*/}
                    {/*            top: '50%',*/}
                    {/*            left: '50%',*/}
                    {/*            transform: 'translate(-50%, -50%)',*/}
                    {/*            fontSize: '24px',*/}
                    {/*            color: '#000'*/}
                    {/*        }}>*/}
                    {/*            Loading 3D Model...*/}
                    {/*        </div>*/}
                    {/*    )}*/}
                    {/*    {error && (*/}
                    {/*        <div style={{*/}
                    {/*            position: 'absolute',*/}
                    {/*            top: '50%',*/}
                    {/*            left: '50%',*/}
                    {/*            transform: 'translate(-50%, -50%)',*/}
                    {/*            fontSize: '24px',*/}
                    {/*            color: 'red'*/}
                    {/*        }}>*/}
                    {/*            Failed to load model.*/}
                    {/*        </div>*/}
                    {/*    )}*/}
                    {/*</div>*/}

                    <div style={{
                        width: '80%',
                        height: '55vh',
                        margin: 'auto',
                        marginBottom: '100px',
                        position: 'relative'
                    }}>
                        {/* Navigation Buttons */}
                        <button
                            onClick={() => carouselRef.current?.prev()}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: 10,
                                transform: 'translateY(-50%)',
                                fontSize: '24px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                cursor: 'pointer',
                                zIndex: 1
                            }}
                        >
                            &#60;
                        </button>
                        <button
                            onClick={() => carouselRef.current?.next()}
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: 10,
                                transform: 'translateY(-50%)',
                                fontSize: '24px',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                cursor: 'pointer',
                                zIndex: 1
                            }}
                        >
                            &#62;
                        </button>

                        {/* Carousel */}
                        <Carousel ref={carouselRef} autoplay dots={true}>
                            <div>
                                <img src="https://i.imgur.com/HllU7l8.png" alt="slide 1"
                                     style={{width: '100%', height: 'auto'}}/>
                            </div>
                            <div>
                                <img src="https://i.imgur.com/tdnxTNM.png" alt="slide 2"
                                     style={{width: '100%', height: 'auto'}}/>
                            </div>
                            <div>
                                <img src="https://i.imgur.com/8vVi1hv.png" alt="slide 3"
                                     style={{width: '100%', height: 'auto'}}/>
                            </div>
                        </Carousel>

                        {/* IGES Viewer */}
                    </div>


                </div>


                <div className={classes['product-section']}>
                    <span>AW5 - DATA SHEET</span>
                    <a
                        href="https://drive.google.com/uc?export=download&id=1e2Z1iws-qwEV_6ogBV7KR9C4DUUS0-KX"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button>Download</button>
                    </a>
                </div>

                <Fotter/>
            </div>
        </div>
    );
}

export default Awfive;